import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const TRUCK = "https://customer-assets.emergentagent.com/job_academy-2/artifacts/2zesbrjw_seedkeepers%20truck%20with%20logo.png";

export default function OnCountryFeature() {
  return (
    <section className="relative py-28 md:py-44 text-cream overflow-hidden" data-testid="oncountry-feature">
      <motion.img
        src={TRUCK}
        alt="SeedKeepers on Country"
        initial={{ scale: 1.12 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 2.4, ease: "easeOut" }}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-charcoal/92 via-charcoal/70 to-charcoal/30" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <div className="bg-black/40 backdrop-blur-[3px] px-6 py-7 md:px-9 md:py-8">
          <p className="overline text-ochre mb-7">On-Country learning</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight">
            Hands-on training, real-world experience.
          </h2>
          <p className="mt-8 text-cream/80 text-lg font-light leading-relaxed">
            The SeedKeepers On-Country Native Seed Intensive combines field work, classroom-style
            learning and hands-on seed processing — identification, collection timing and methods,
            documentation, handling, cleaning, storage and propagation fundamentals. Each intensive
            is adapted to local Country, species, season and organisational priorities.
          </p>
          </div>

          <div className="mt-12 flex flex-wrap gap-4">
            <Link to="/on-country" data-testid="oncountry-explore" className="bg-cream text-rainforest px-8 py-4 text-sm tracking-wide hover:bg-sandstone transition-colors">
              Explore On-Country Learning
            </Link>
            <Link to="/contact" data-testid="oncountry-call" className="border border-cream/50 text-cream px-8 py-4 text-sm tracking-wide hover:bg-cream hover:text-rainforest transition-colors">
              Request a Planning Call
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
